import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModelsTransformUtil } from '@ddt-web/common';
import { Model } from '@ddt-web/data-service';
import { ModelPortfolio } from '@ddt-web/domain';
import { ModelNameUtil } from '@ddt-web/generic-utils';
import * as cloneDeep from 'lodash/cloneDeep';

import { PortfolioFamily } from '../../../models/model-portfolio.interface';
import { PillsFilterType } from '../pills/pills-filter-type.enum';

@Component({
	selector: 'mp-model-list-container',
	templateUrl: './model-list-container.component.html',
	styleUrls: ['./model-list-container.component.scss']
})
export class ModelListContainerComponent implements OnInit {
	public readonly COMPARE = 'COMPARE';
	public readonly NEW = 'NEW';

	@Input() public selectedModelPortfolios: ModelPortfolio[] = [];
	@Input() public allFamilies: PortfolioFamily[] = [];
	@Input() public showCheckboxes: boolean = false;
	@Input() public allowMultiple: boolean = true;
	@Input() public pillsFilterType: PillsFilterType;
	@Input() public mode: 'NEW' | 'COMPARE' = this.NEW;
	@Input() public maxLimit: number = 100;
	@Input() public arrowLeft: boolean = false;
	@Input() public hidePills: boolean = false;
	@Input() public useDasPortfolioId: boolean = false;
	@Output() public onModelSelected: EventEmitter<any> = new EventEmitter();

	public filteredFamilies: PortfolioFamily[] = [];
	private filteredAllFamilies: PortfolioFamily[] = [];

	public ngOnInit(): void {
		// Filtered families used while searching
		const allFamiliesClone = cloneDeep(this.allFamilies);
		this.filteredAllFamilies = ModelsTransformUtil.sortModelPortfolios(allFamiliesClone, 'displayOrder');
		this.filteredFamilies = cloneDeep(this.filteredAllFamilies);
	}

	public filterModels(searchText: string): void {
		searchText = searchText.toLowerCase();

		this.filteredAllFamilies.forEach((family, index) => {
			this.filteredFamilies[index].portfolios = this.filterModelPortfolios(family.portfolios, searchText);
		});
	}

	public onModelPortfolioSelected(): void {
		this.onModelSelected.emit();
	}

	private filterModelPortfolios(portfolios: Model[], searchText: string): Model[] {
		return portfolios.filter(portfolio => ModelNameUtil.getModelExternalName(portfolio, portfolio.name).toLowerCase().includes(searchText));
	}

}
